import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';
import type { InvoiceKind } from '@/shared/api';

type CreateKind = Extract<InvoiceKind, 'Manual' | 'DamageClaim'>;

interface Props {
  open: boolean;
  pending: boolean;
  onOpenChange: (open: boolean) => void;
  onCreate: (kind: CreateKind) => void;
}

/** Die fachliche Wahl steht vor dem Entwurf, damit ein Schaden nie als Rechnung beginnt. */
export function InvoiceKindDialog({ open, pending, onOpenChange, onCreate }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Beleg erstellen</DialogTitle>
          <p className="text-ink-soft mt-1 text-sm">Wähle den fachlich passenden Belegtyp.</p>
        </DialogHeader>
        <DialogBody className="space-y-3">
          <button
            type="button"
            onClick={() => onCreate('DamageClaim')}
            disabled={pending}
            className="border-sage bg-sage-pale/40 hover:bg-sage-pale focus-visible:ring-sage w-full rounded-md border p-4 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 disabled:opacity-50"
          >
            <span className="text-ink block font-medium">Schadensersatzforderung</span>
            <span className="text-ink-soft mt-1 block text-sm">
              Für einen echten, vom Gast verursachten Sachschaden ohne Leistungsaustausch.
            </span>
          </button>
          <button
            type="button"
            onClick={() => onCreate('Manual')}
            disabled={pending}
            className="border-line hover:bg-card-alt focus-visible:ring-sage w-full rounded-md border p-4 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 disabled:opacity-50"
          >
            <span className="text-ink block font-medium">Sonstige Rechnung</span>
            <span className="text-ink-soft mt-1 block text-sm">
              Für eine steuerpflichtige, manuell berechnete Leistung.
            </span>
          </button>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={pending}>
            Abbrechen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
